import React from "react";
import BottomBarNavigationItem from "./BottomBarNavigationItem.js";
import { FormattedMessage } from "react-intl";
import { LocalizationMessages } from "../../../localization/messages.js";
import { AppHelpers } from "../../../hooks/useWidgetInitialization/helpers.js";
import { NavigationUtils } from "../../../utils/index.js";
import { UISelectors } from "../../../redux/selectors/index.js";
import { useSelector } from "react-redux";

const HomeBottomBarNavigationItem = () => {
  const links = useSelector(UISelectors.links);

  const onHomeClick = () => {
    AppHelpers.toggleBetslipVisibility(false);
    NavigationUtils.navigateTo(links.home);
  };

  return (
    <BottomBarNavigationItem
      onClick={onHomeClick}
      iconColor={"white"}
      iconLabel={"home"}
      dataTestId={"bottom-navigation-home"}
      googleAnalyticsLabel={"home"}
    >
      <FormattedMessage {...LocalizationMessages.bottomNavigationHome} />
    </BottomBarNavigationItem>
  );
};

export default React.memo(HomeBottomBarNavigationItem);

HomeBottomBarNavigationItem.propTypes = {};
